import styled from "styled-components";
import UiButton from "components/pm/decisions/ui-button";

const Styled = {};

Styled.BodyWrapper = styled.div`
  background: #e5e5e5;
  padding: 56px 56px 0;
  width: 100%;

  .loader {
    max-width: 800px;

    .loader-inner {
      div {
        margin-left: auto;
        margin-right: auto;
        margin-top: 100px;
        border-color: #2a4169;
      }
    }
  }
`;

Styled.TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 15px;
`;

Styled.Title = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 24px;
  line-height: 29px;
  color: #000;
  padding-right: 20px;
`;

Styled.SubmitDecisionButton = styled.div`
  display: inline-block;
  height: 23px;
  width: 148px;
  line-height: 23px;
  text-align: center;
  font-family: Lato;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
  background-color: ${({ submitted }) =>
    submitted ? "#52c5cd" : "rgba(255, 0, 0, 0.75)"};
  border-radius: 5px;

  .fa-spinner,
  .fa-check {
    margin-right: 10px;
  }

  &:hover {
    cursor: pointer;
  }
`;

Styled.ButtonsWrapper = styled.div`
  padding: 0 15px;
`;

Styled.ButtonsWrapperFlex = styled.div`
  display: flex;
  align-items: center;
`;

Styled.UIButton = styled(UiButton)`
  display: block;
  padding: 0 !important;
  min-width: auto !important;
  border-color: transparent !important;
  width: 156px !important;
  height: 43px !important;
  line-height: 43px !important;
  background-color: #2a4169 !important;
  font-family: Lato !important;
  font-weight: bold !important;
  font-size: 14px !important;
  color: #fff !important;
  border-radius: 4px !important;
  transition: background-color 0.5s ease;

  &:hover {
    background-color: #0da6ad !important;
  }

  &:disabled {
    background-color: #cccccc !important;
  }
`;

Styled.Arrow = styled.div`
  margin-left: 20px;
  margin-right: 20px;
`;

Styled.WhiteBlock = styled.div`
  background: #fff;
  width: 100%;
  margin-top: 32px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  max-width: 800px;
  padding: 25px;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
`;

Styled.WhiteBlockColumn = styled.div`
  flex: 0 0 345px;
  position: relative;

  ${p =>
    p.width &&
    `
    flex: 0 0 ${p.width};
  `}
`;

// current marketing spend
Styled.CMS = {};

Styled.CMS.Title = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: #000;
`;

Styled.CMS.Amount = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 12px;
  line-height: 12px;
  color: #fff;
  background: #494949;
  width: 52px;
  height: 52px;
  border-radius: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 79px;
  left: 42px;
`;

Styled.CMS.Chart = styled.div`
  .recharts-legend-wrapper {
    font-family: Lato;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    color: #000000;

    svg {
      width: 9px;
      height: 9px;
      position: relative;
      top: -1px;
    }

    .recharts-default-legend {
      position: relative;
      top: 15px;
      left: 15px;
    }
  }
`;

// revenue forecast
Styled.RF = {};

Styled.RF.Title = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: #000;
`;

Styled.RF.Table = styled.div`
  table {
    width: 100%;
    border: 0;
    border-collapse: separate;

    thead {
      border: 0;

      tr {
        th {
          padding: 12px 13px;
          font-family: Lato;
          font-size: 14px;
          line-height: 17px;
          text-align: center;
          color: #74abec;
          border-bottom: 1px solid #626262;
        }
      }
    }

    tbody {
      tr {
        td {
          border-top: 9px solid #fff;
          font-family: Lato;
          font-weight: bold;
          font-size: 14px;
          line-height: 17px;
          color: #000000;
          text-align: center;
          padding: 2px 0;

          ${p =>
    p.rowColor &&
    `
            background: ${p.rowColor};
          `}

          .remove-operation {
            line-height: 25px;
            top: 0;
          }
        }

        &:first-child {
          td {
            border-top: 12px solid #fff;
          }
        }
      }
    }
  }
`;

// promotional spend
Styled.PS = {};

Styled.PS.Title = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: #000;
`;

Styled.PS.Amount = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 12px;
  line-height: 12px;
  color: #fff;
  background: #494949;
  width: 52px;
  height: 52px;
  border-radius: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 79px;
  left: 42px;
`;

Styled.PS.Chart = styled.div`
  .recharts-legend-wrapper {
    font-family: Lato;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    color: #000000;

    svg {
      width: 9px;
      height: 9px;
      position: relative;
      top: -1px;
    }

    .recharts-default-legend {
      position: relative;
      top: 45px;
      left: -10px;
    }
  }
`;

Styled.PS.Table = styled.div`
  margin-top: 30px;

  table {
    width: 100%;
    border: 0;
    border-collapse: separate;

    thead {
      border: 0;

      tr {
        th {
          padding: 12px 13px;
          font-family: Lato;
          font-size: 14px;
          line-height: 17px;
          text-align: center;
          color: #74abec;
          border-bottom: 1px solid #626262;
        }
      }
    }

    tbody {
      tr {
        td {
          border-top: 9px solid #fff;
          font-family: Lato;
          font-weight: bold;
          font-size: 14px;
          line-height: 17px;
          color: #000000;
          text-align: center;
          padding: 2px 0;

          ${p =>
    p.rowColor &&
    `
            background: ${p.rowColor};
          `}

          .remove-operation {
            line-height: 25px;
            top: 0;
          }
        }

        &:first-child {
          td {
            border-top: 12px solid #fff;
          }
        }
      }
    }
  }
`;

// placement
Styled.P = {};

Styled.P.Title = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: #000;
`;

Styled.P.Amount = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 12px;
  line-height: 12px;
  color: #fff;
  background: #494949;
  width: 52px;
  height: 52px;
  border-radius: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 79px;
  left: 42px;
`;

Styled.P.Chart = styled.div`
  .recharts-legend-wrapper {
    font-family: Lato;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    color: #000000;

    svg {
      width: 9px;
      height: 9px;
      position: relative;
      top: -1px;
    }

    .recharts-default-legend {
      position: relative;
      top: 45px;
      left: -70px;
    }
  }
`;

Styled.P.Table = styled.div`
  margin-top: 30px;

  table {
    width: 100%;
    border: 0;
    border-collapse: separate;

    thead {
      border: 0;

      tr {
        th {
          padding: 12px 13px;
          font-family: Lato;
          font-size: 14px;
          line-height: 17px;
          text-align: center;
          color: #74abec;
          border-bottom: 1px solid #626262;
        }
      }
    }

    tbody {
      tr {
        td {
          border-top: 9px solid #fff;
          font-family: Lato;
          font-weight: bold;
          font-size: 14px;
          line-height: 17px;
          color: #000000;
          text-align: center;
          padding: 2px 0;

          ${p =>
    p.rowColor &&
    `
            background: ${p.rowColor};
          `}

          .remove-operation {
            line-height: 25px;
            top: 0;
          }
        }

        &:first-child {
          td {
            border-top: 12px solid #fff;
          }
        }
      }
    }
  }
`;

Styled.TextWithButton = styled.span`
  display: inline-flex;
  align-items: center;
`;

Styled.HelpIcon = styled.img`
  width: 14px;
  height: 14px;
  margin-left: 4px;
  cursor: pointer;
`;

export default Styled;



// WEBPACK FOOTER //
// ./src/components/pm/style.js